const getPercepciones = async clienteStr => {
  return false;
};

const percepciones = {
  getPercepciones,
};

export default percepciones;
